<template>
    <div>
        <a class="btn btn-sm btn-primary" style="margin-top: -10px;" href="" @click.prevent.stop="createPurchaseOrder()">
            Add Purchase Order
        </a>
        <br>

        <div style="display: block">
            <form>
                <vue-element-loading text="Loading Purchase Orders..." :active="loading"
                                     spinner="bar-fade-scale" color="#FF6700"/>
                <table style="margin-top:7px;" width="100%" border="1" cellspacing="0">
                    <tr>
                        <th><b>Date</b></th>
                        <th><b>P.O.#</b></th>
                        <th><b>PO Doc(s)</b></th>
                        <th><b>Proposal</b></th>
                        <th><b>P.O. Notes</b></th>
                        <th><b>Site #\'s in P.O.</b></th>
                        <th><b>Svc Tkt/Job #\'s</b></th>
                        <th><b>Assign this PO</b></th>
                        <th><b>Billing Acct#</b></th>
                        <th><b>Customer</b></th>
                        <th><b>Sales Person</b></th>
                        <th><b>Amount</b></th>
                    </tr>
                    <tbody>
                    <tr v-for="record in records">
                        <td>{{ record.date }}</td>
                        <td> <a  href="" @click.prevent.stop="openModal(record.id)">{{ record.po_number }}</a></td>
                        <td v-html="record.po_docs"></td>
                        <td v-html="record.proposal"></td>
                        <td v-html="record.notes"></td>
                        <td v-html="record.site_number"></td>
                        <td v-html="record.svc"></td>
                        <td><input v-model="po_id" name="po_number" @change="updatePO" type="radio"
                                   :value="record.id">
                            <a v-if="record.id === po_id" class="text-danger ml-2" href="" title="Detach PO" @click.prevent.stop="deleteStn()"><i class="fa fa-times"></i></a>
                        </td>
                        <td>{{ record.billing_account }}</td>
                        <td>{{ record.customer }}</td>
                        <td>{{ record.salesperson }}</td>
                        <td>{{ record.amount }}</td>
                    </tr>
                    </tbody>
                </table>
            </form>
        </div>

        <div  class="modal fade" id="actionAddPOModal" tabindex="-1" role="dialog"
             style="z-index: 999999;"
             :aria-labelledby="'actionAddPOModalLabel_'"
             aria-hidden="true">
            <div class="modal-dialog" :class="'modal-xl'" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" :id="'actionAddPOModalLabel_'">
                            <span v-if="editPO">Edit Purchase Order</span>
                            <span v-else>Create Purchase Order</span>
                        </h5>
                        <button type="button" class="close"   @click="closeSpecificModal('actionAddPOModal')"  aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body"  style="height: 78vh; overflow-y: scroll">
                        <iframe v-if="addNewPO" :ref="'actionAddPOIframe'"
                                :src="this.action"
                                style="width: 100%; height: 100%; border: none; "></iframe>
                    </div>
                    <div class="modal-footer" style="display: block; text-align: right">
                        <button type="button" class="btn btn-warning"  @click="closeSpecificModal('actionAddPOModal')" >Close</button>
                        <button type="button" @click="saveUpdate" class="btn btn-primary">
                            <span v-if="editPO">Update record</span>
                            <span v-else> Save Entry As New</span>
                        </button>
                        <button v-if="editPO" type="button" @click="saveEntryAsNew" class="btn btn-success">Save Entry As New</button>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import BillingMonth from "../billings/BillingMonth.vue";

export default {
    name: "CustomerPurchaseOrderSelect",
    components: {VueElementLoading},

    props: {
        serviceTicketNumber: {
            type: String,
            default: null,
        },
        siteId: {
            type: Number,
            default: null,
        }
    },
    data() {
        return {
            records: [],
            po_id: null,
            loading:false,
            addNewPO: false,
            editPO: false,
            action: ''
        };
    },
    mounted() {
        this.getCustomerPurchaseOrders()
    },
    methods: {

        saveUpdate(){
            this.$refs['actionAddPOIframe'].contentWindow.postMessage(
                {
                    name: 'po_add',
                    action: "saveForm"
                }, '*');
        },
        saveEntryAsNew(){
            this.$refs['actionAddPOIframe'].contentWindow.postMessage(
                {
                    name: 'po_add',
                    action: "saveFormAsNew"
                }, '*');
        },
        closeSpecificModal(modalId){
            if (modalId === 'actionAddPOModal') {
                this.addNewPO = false;
                this.editPO = false;
                $('#actionAddPOModal').modal('hide')
                this.getCustomerPurchaseOrders()
            }
        },
        openModal(id){
            this.addNewPO = true;
            this.action = '/customer_pos/' + id +'/edit?iframe=true'
            this.editPO = true;
            $('#actionAddPOModal').modal('show')
          //  popupwindow('/customer_pos/' + id +'/edit', '_blank')
        },

        createPurchaseOrder(){
            this.addNewPO = true;
            this.action = '/customer_pos/create?iframe=true&site_id='+this.siteId+'&serviceTicket='+this.serviceTicketNumber
            $('#actionAddPOModal').modal('show')
            //popupwindow('/customer_pos/create?iframe=true&site_id='+this.siteId+'&serviceTicket='+this.serviceTicketNumber, '_blank')
        },

        async updatePO() {
            let app = this;
            await axios.post(`/schedules/service-ticket/${this.serviceTicketNumber}/attach-customer-purchase-order`,{
                po_id: this.po_id
            }).then((response) => {
                showMessage('s', 'Successfully Assigned PO!');
                app.getCustomerPurchaseOrders()
                app.$emit('updatePo', app.po_id)
            })
                .catch((err) => {
                    showMessage('e', 'Error loading purchase orders');
                    console.error(err);
                }).finally((e) => app.loading = false)

        },

        async deleteStn() {
            let app = this;
            await axios.post(`/schedules/service-ticket/${this.serviceTicketNumber}/detach-customer-purchase-order`,{
                po_id: this.po_id
            }).then((response) => {
               app.po_id = null;
               app.getCustomerPurchaseOrders();
            })
                .catch((err) => {
                    showMessage('e', 'Error loading purchase orders');
                    console.error(err);
                }).finally((e) => app.loading = false)

        },

        async getCustomerPurchaseOrders() {
            let app = this;
            this.loading = true;
            await axios.get(`/schedules/service-ticket/${this.serviceTicketNumber}/customer-purchase-order?site_id=${this.siteId}`).then((response) => {
                app.records = response.data;
                for (let i = 0; i < app.records.length; i++) {
                    if (app.records[i].stns.includes(app.serviceTicketNumber)) {
                        this.po_id = app.records[i].id
                        app.$store.commit('schedules/schedulePO', app.records[i].po_number)
                    }
                }
            })
                .catch((err) => {
                    showMessage('e', 'Error loading purchase orders');
                    console.error(err);
                }).finally((e) => app.loading = false)

        },
    }
}

</script>
